<fa-icon *ngIf="icon" class="notification-icon" [icon]="icon" [fixedWidth]="true"></fa-icon>
<div class="notification-body">
  <div class="notification-content">
    <div *ngIf="header" class="notification-title" [innerHTML]="header | translate"></div>
    <div *ngIf="subheader" class="notification-subtitle" [innerHTML]="subheader | translate"></div>
    <div *ngIf="message" class="notification-message" [innerHTML]="message"></div>
  </div>
  <div class="notification-actions">
    <ng-content></ng-content>
  </div>
</div>
<fa-icon
  *ngIf="dismissible"
  class="notification-dismiss"
  icon="times-circle"
  [fixedWidth]="true"
  (click)="onDismiss($event)"
></fa-icon>
